/**
 * AttachmentUploadArea - Zona de upload compartilhada para anexos
 * 
 * Componente reutilizável de drop zone para upload de arquivos
 * usado nos módulos CRM (Deals) e Tarefas.
 * 
 * Versão: 1.0.0
 * RELEASE: 2026-04-06 v1.0.0 - Extração de componente duplicado
 */
import React from 'react';
import { Upload, Loader2 } from 'lucide-react';

/** Props do componente */
interface AttachmentUploadAreaProps {
  /** Callback ao clicar na área de upload */
  onUploadClick: () => void;
  /** Indica se um upload está em andamento */
  isUploading: boolean;
  /** Texto descritivo do limite de tamanho */
  maxSizeLabel?: string;
  /** Classes CSS adicionais */
  className?: string;
}

/**
 * Área de upload com ícone, texto e indicador de loading
 */
export function AttachmentUploadArea({
  onUploadClick,
  isUploading,
  maxSizeLabel = 'Máx: 10MB por arquivo',
  className,
}: AttachmentUploadAreaProps) {
  return (
    <div
      className={`border-2 border-dashed rounded-lg p-3 text-center cursor-pointer hover:border-primary/50 hover:bg-accent/50 transition-colors ${className || ''}`}
      onClick={onUploadClick}
    >
      {isUploading ? (
        <Loader2 className="h-5 w-5 mx-auto mb-1 animate-spin text-muted-foreground" />
      ) : (
        <Upload className="h-5 w-5 mx-auto mb-1 text-muted-foreground" />
      )}
      <p className="text-xs text-muted-foreground">
        {isUploading ? 'Enviando...' : 'Clique para adicionar arquivos'}
      </p>
      <p className="text-[10px] text-muted-foreground/70">{maxSizeLabel}</p>
    </div>
  );
}
